import { Modal } from '@/components';
import { Button, Image } from '@/ui';
import styled from 'styled-components';

export const StyledImageCard = styled.div`
  position: relative;
  &:hover {
    & > button {
      visibility: visible;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const StyledImage = styled(Image)`
  &.ant-image-img {
    width: 12rem;
    height: 12rem;
  }
`;

export const StyledButton = styled(Button)`
  visibility: hidden;
  position: absolute;
  bottom: 3%;
  right: 3%;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledModal = styled(Modal)`
  .ant-modal-title {
    text-align: center;
  }
`;
